module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ORIM-Book-Title"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("MURDER, STAGE LEFT")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Book-Subtitle"
  }, [_vm._v("A Nero Wolfe Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Author-Name ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Robert\n\t\t\t\tGoldsborough")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Author-Name ParaOverride-3"
  }, [_c('img', {
    attrs: {
      "src": "image/logo3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("To Otto Penzler,"), _c('br'), _vm._v("Publisher and editor extraordinaire,\n\t\t\t"), _c('br'), _vm._v("for his continuing support and encouragement")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3295799a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = 69
// module chunks = 0